import { generateVariantData } from '../../../../experiments/utils';

const gifURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/accounts`;
const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/flagship/home-page`;

const codingSkills = [
  {
    header: 'On-Demand Classes',
    body:
      'Our online classes are designed to accelerate coding skills. Tap into our full library of educational coding videos and take independent learning to the next level.',
    valueProps: [
      'Access 360 minutes of pre-recorded classes with unlimited replay',
      'Learn coding and game design principles at your own pace',
      'Watch anytime, anywhere, on your family’s own schedule',
    ],
    img: `${gifURL}/joyfulandempowering/smallgroupclasses-gif (1).gif`,
  },
  {
    header: '#1 Learn-to-Code App',
    body:
      'Our curriculum is based on research from MIT, Princeton & Carnegie Mellon, personalized to your child’s progress, and loved by kid coders and parents alike.',
    valueProps: [
      'Hundreds of puzzles & games that teach the ABCs of coding',
      'Kids level up their skills by building and coding their own games',
      'Just 90 minutes of play increases confidence & problem solving skills',
    ],
    img: `${gifURL}/v2.0.4_GIFs/app-gif.gif`,
  },
];

const digitalWorkbooks = {
  header: 'Digital Workbook',
  body:
    'Practice coding offline with our print friendly digital workbook. Use a hands-on approach to reinforce what you learn in the app, anywhere you go.',
  valueProps: [
    'Includes over 50+ pages of coding activities',
    'Progress through exercises, quizzes, and puzzles that range from easy to hard',
    'Includes design maps to outline your next game design before building in the app',
  ],
  img: `${imgURL}/digital-workbooks.png`,
};

const videoClasses = {
  header: 'Video Classes',
  body:
    'Accelerate your coding skills with step-by-step instructions from one of our expert teachers. Learn tips & tricks to expand your coding creativity with exclusive design templates, available only through our classes.',
  valueProps: [
    'Access 12 video lessons with unlimited replay',
    'Learn coding and game design principles at your own pace',
    'Watch anytime, anywhere, on your family’s own schedule',
  ],
  img: `${imgURL}/video-classes.png`,
};

const selfPacedClasses = {
  ...videoClasses,
  header: 'Self-Paced Classes',
  valueProps: [
    'Access 12 self-paced lessons with unlimited replay',
    'Learn coding and game design principles at your own pace',
    'Watch anytime, anywhere, on your family’s own schedule',
  ],
};

const variantToDataMapping = {
  homepageRedesign: {
    header: 'Activate their coding skills',
    codingSkills: codingSkills,
  },
  premiumOndemandClasses: {
    header: 'Activate their coding skills',
    codingSkills: [videoClasses, codingSkills[1], digitalWorkbooks],
  },
  premiumVsStandardDesign: {
    header: 'Activate their coding skills',
    codingSkills: [
      selfPacedClasses,
      codingSkills[1],
      digitalWorkbooks,
    ],
  },
};

const DEFAULT_DATA_KEY = 'premiumVsStandardDesign';
export const getActivateCodingSkillsVariantData = generateVariantData(
  variantToDataMapping,
  DEFAULT_DATA_KEY
);



// WEBPACK FOOTER //
// ./src/containers/Home/sections/ActivateCodingSkills/activateCodingSkillsData.js